<template>
    <div class="duishi">
        <div :class="['options', {active: i === 1}]" @touchend="seleted(list[dsIndex].s, 0)" @touchstart="i = 1">{{list[dsIndex].info[0]}}</div>
        <div :class="['options', {active: i === 2}]" @touchend="seleted(list[dsIndex].s, 1)" @touchstart="i = 2">{{list[dsIndex].info[1]}}</div>
        <div :class="['options', {active: i === 3}]" @touchend="seleted(list[dsIndex].s, 2)" @touchstart="i = 3">{{list[dsIndex].info[2]}}</div>
    </div>
</template>

<script>
export default {
    props: ['dsIndex'],
    data() {
        return {
            list: [
                {
                    s: 2,
                    info: ['玉碗盛来琥珀光', '斗酒相逢须醉倒', '但愿长醉不愿醒']
                },
                {
                    s: 1,
                    info: ['高会谁能解酒貂', '神血未凝身问谁', '斗酒十千恣欢谑']
                },
                {
                    s: 0,
                    info: ['尽日灵风不满旗', '忆向天阶问紫芝', '已共孤山入画图']
                }
            ],
            i: 0
        };
    },
    methods: {
        seleted(flg, index) {
            this.i = 0;
            setTimeout(() => {
                this.$emit('result', flg === index);
            }, 500);
        }
    }
};
</script>

<style lang="stylus" scoped>
.duishi
    position absolute
    right 0
    top 26%
    .options
        size 4rem .72rem
        font-size .32rem
        color #fff
        padding 0.22rem 0 0 1.13rem
        margin-bottom .3rem
        opacity 0
        background url('/img/xj/choise_bg.png') 0 0/100% 100% no-repeat
        animation show .6s cubic-bezier(0.55, 0.085, 0.68, 0.53)
        animation-fill-mode forwards
        &:nth-child(2)
            animation-delay .5s
        &:nth-child(3)
            animation-delay 1s
        &.active
            transform scale(1.1);
            transition all .5s;
</style>
